import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { getTourRun, getTourSteps, getTourStepIndex } from 'store/entities/tour/selectors'
import { setRun, setStepIndex } from 'store/entities/tour/actions'
import { setQueries } from 'store/entities/localSettings/actions'
import Tour from './Tour'

const mapStateToProps = createStructuredSelector({
  run: getTourRun,
  steps: getTourSteps,
  stepIndex: getTourStepIndex,
})

const mapDispatchToProps = {
  setRun,
  setStepIndex,
  setQueries,
}

export default connect(mapStateToProps, mapDispatchToProps)(Tour)
